import { ReactNode } from 'react'
import { Stack } from '@mui/material'

type HorizontalTabsProps = {
  children: ReactNode
}

export default function HorizontalTabs({ children }: HorizontalTabsProps) {
  return (
    <Stack direction="row" spacing={0.5}>
      {children}
    </Stack>
  )
}
